module.exports = __webpack_public_path__ + "img/1965.cf222caf.jpg";